import { lazy } from 'react';
import Loadable from 'components/Loadable';

const UsersList = Loadable(lazy(() => import('./components/users-list/UsersList')));
const RolesPage = Loadable(lazy(() => import('./components/roles-page/RolesPage')));
const PermissionsPage = Loadable(lazy(() => import('./components/permissions-page/PermissionsPage')));
const ApprovalWorkflows = Loadable(lazy(() => import('./components/approval-workflows/ApprovalWorkflows')));

export const userManagementRoutes = {
  path: 'user-management',
  children: [
    { index: true, element: <UsersList /> },
    { path: 'users', element: <UsersList /> },
    { path: 'roles', element: <RolesPage /> },
    { path: 'permissions', element: <PermissionsPage /> },
    { path: 'approval-workflows', element: <ApprovalWorkflows /> }
  ]
};

export default userManagementRoutes;
